var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('span',{staticClass:"title"},[_vm._v("Vue Trello")]),_c('router-link',{staticClass:"btn-header",attrs:{"to":""}},[_vm._v("Mis Paneles")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }